import getApi from '../../api'
import { ApiDocumentLayoutResource } from '../../model/DocumentLayout'
import { deserializeDocumentLayoutResponse } from './mapper/documentLayouts.mapper'

export const getDocumentLayout = (id: number) =>
  getApi()
    .get<ApiDocumentLayoutResource>(`/document_layouts/${id}`)
    .then(deserializeDocumentLayoutResponse)
